import React from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { FiTrash2, FiRepeat, FiXCircle } from "react-icons/fi";

import { Status } from "../../utils/constants";

import avatarDefault from "../../images/avatar-default.png";

export default ({ id, title, details, author, createdAt, closedAt, upvotes, downvotes, upvoted, downvoted, permissions, handleStatus, handleVote, handleDelete, authenticated }) => {
    return (
        <div>
            <div
                css={{
                    width: "100%",
                    padding: 15,
                    marginBottom: 25,
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "rgba(100, 100, 100, .1)",
                    borderRadius: 5,
                    border: "1px solid rgba(100, 100, 100, .3)",
                }}
            >
                <div
                    css={{
                        fontWeight: 500,
                        marginBottom: 10,
                    }}
                >
                    { title }
                </div>

                <div
                    title={ closedAt ? "Closed on " + closedAt.toLocaleString() : null }
                    css={{
                        display: "flex",
                        marginBottom: 10,
                        fontSize: ".8em",
                        fontWeight: 500,
                        color: closedAt ? "var(--red)" : "var(--blue)",
                        textTransform: "uppercase",
                    }}
                >
                    { closedAt ? "Closed" : "Open" }
                </div>

                {
                    details && details.length
                    ?   <div
                            css={{
                                color: "lightgrey",
                                fontSize: ".9em",
                            }}
                        >
                            {
                                details.split('\n').map((item, key) =>
                                    <span key={ key }>
                                        { item }
                                        <br/>
                                    </span>
                                )
                            }
                        </div>
                    :   null
                }
            </div>

            <div css={{
                marginBottom: 25,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                fontSize: ".9em",
            }}>
                <div css={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <div
                        css={{
                            padding: 5,
                            marginRight: 5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            color: upvoted ? "var(--green)" : "inherit",
                            transition: "background-color var(--transition-default-time) ease-in-out, color var(--transition-default-time) ease-in-out",
                            cursor: authenticated ? "pointer" : "not-allowed",
                            ":hover": {
                                borderRadius: 3,
                                backgroundColor: "rgba(100, 100, 100, .2)",
                                color: "var(--green)",
                            },
                        }}
                        onClick={ () => authenticated ? upvoted ? handleVote(0) : handleVote(1) : null }
                    >
                        <IoIosArrowUp />
                    </div>
                    <div css={{
                        textAlign: "center",
                    }}>
                        { (upvotes || 0) - (downvotes || 0) }
                    </div>
                    <div
                        css={{
                            padding: 5,
                            marginLeft: 5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            color: downvoted ? "var(--red)" : "inherit",
                            transition: "background-color var(--transition-default-time) ease-in-out, color var(--transition-default-time) ease-in-out",
                            cursor: authenticated ? "pointer" : "not-allowed",
                            ":hover": {
                                borderRadius: 3,
                                backgroundColor: "rgba(100, 100, 100, .2)",
                                color: "var(--red)",
                            },
                        }}
                        onClick={ () => authenticated ? downvoted ? handleVote(0) : handleVote(-1) : null }
                    >
                        <IoIosArrowDown />
                    </div>
                </div>

                {
                    permissions
                    ?   <div css={{
                            display: "flex",
                            alignItems: "center",
                        }}>
                            <div
                                css={{
                                    padding: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    transition: "background-color var(--transition-default-time) ease-in-out, color var(--transition-default-time) ease-in-out",
                                    ":hover": {
                                        borderRadius: 3,
                                        backgroundColor: "rgba(100, 100, 100, .2)",
                                        color: closedAt ? "var(--green)" : "var(--orange)",
                                    },
                                }}
                                onClick={ () => closedAt ? handleStatus(Status.OPEN) : handleStatus(Status.CLOSE) }
                            >
                                {
                                    closedAt
                                    ?   <FiRepeat />
                                    :   <FiXCircle />
                                }
                                <span css={{ marginLeft: 5 }}>
                                    {
                                        closedAt
                                        ?   "Reopen"
                                        :   "Close"
                                    }
                                </span>
                            </div>

                            <div
                                css={{
                                    padding: 5,
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    transition: "background-color var(--transition-default-time) ease-in-out, color var(--transition-default-time) ease-in-out",
                                    ":hover": {
                                        borderRadius: 3,
                                        backgroundColor: "rgba(100, 100, 100, .2)",
                                        color: "var(--red)",
                                    },
                                }}
                                onClick={ handleDelete }
                            >
                                <FiTrash2 />
                                <span css={{ marginLeft: 5 }}>
                                    Delete
                                </span>
                            </div>
                        </div>
                    :   null
                }
            </div>

            <div css={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                <div css={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <img
                        alt="Avatar"
                        src={
                            author && author.github
                            ?   "https://avatars2.githubusercontent.com/u/" + author.github + "?size=128"
                            :   avatarDefault
                        }
                        width={ 42 }
                        height={ 42 }
                        css={{
                            marginRight: 15,
                            borderRadius: 3,
                        }}
                    />
                    <div css={{
                        color: "lightgrey",
                        fontSize: ".8em",
                    }}>
                        <div css={{
                            color: "darkgrey",
                            fontSize: ".8em",
                        }}>
                            Posted by
                        </div>
                        <div>
                            { author ? author.name : "Anonymous" }
                        </div>
                    </div>
                </div>


                <div css={{
                    textAlign: "right",
                    color: "lightgrey",
                    fontSize: ".8em",
                }}>
                    <div css={{
                        color: "darkgrey",
                        fontSize: ".8em",
                    }}>
                        Posted on
                    </div>
                    <div>{ createdAt.toLocaleString() }</div>
                </div>
            </div>
        </div>
    );
};
